/* eslint-disable no-return-assign */
/* eslint-disable no-console */

export const Toasters = (msg) =>
{
	switch (msg)
	{
		case 'Network Error':
			return 'networkErr';
		case 'Access Denied':
			return 'accessDenied';
		case 'Unauthorized Access':
			return 'unauthorizedaccess';
		case 'Invalid Request':
			return 'invalidrequest';
		case 'Please try again!':
			return 'plztryagain';
		case 'Not Found':
			return 'notfound';
		case 'Invalid Params':
			return 'invalidparams';
		case 'An account with the given email already exists.':
			return 'accountWithGivenmailexists';
		case 'Mobile Number Already Exist':
			return 'mobileNumberExist';
		case 'Invalid verification code provided,please try again.':
			return 'invalidverification';
		case 'BookMark Not Found':
			return 'bookmarkNotFound';
		default:
			return 'null';
	}
};
